var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"fixed":"","color":"black","dark":"","height":50}},[_c('v-spacer'),_c('v-img',{attrs:{"aspect-ratio":16 / 9,"contain":"","width":"60","height":"50","max-width":"250","src":_vm.logo},on:{"click":_vm.checkIsHome}}),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }